// TODO: autogenerate this on build in the future

export interface Icon {
  viewBox?: string;
  category: 'utility' | 'social';
  svg: string;
}

const enum ICON_CATEGORY {
  UTILITY = 'utility',
  SOCIAL = 'social'
}

export const icons: Record<string, Icon> = {
  // Utility icons
  'arrow-down': {
    svg: `<path d="M5 9l3 3 3-3"/><path d="M8 4v8"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  'arrow-up-down': {
    svg: `<path d="M1 9L4 12L7 9"/>
    <path d="M4 4V12"/>
    <path d="M15 7L12 4L9 7"/>
    <path d="M12 4V12"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  'arrow-up': {
    svg: `<path d="M11 7L8 4 5 7"/>
    <path d="M8 4v8"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  bin: {
    svg: `<path d="M1 4h14M6 1h4"/>
    <path d="M13 7v5a2 2 0 01-2 2H5a2 2 0 01-2-2V7"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  'chevron-down': {
    svg: `<path d="M13 6l-5 5-5-5"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  'chevron-left': {
    svg: `<path d="M10 13L5 8L10 3"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  'chevron-right': {
    svg: `<path d="M6 13L11 8L6 3"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  'chevron-up': {
    svg: `<path d="M3 10l5-5 5 5"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  'circle-arrow': {
    svg: `<path d="M13 9a5 5 0 11-5-5h4M12 4L9 1M12 4L9 7"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  cross: {
    svg: `<path d="M3 13L13 3M3 3l10 10L3 3z"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  download: {
    svg: `<path d="M5 7L8 10L11 7"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 1V10" stroke-width="2" stroke-linecap="round"/>
    <path d="M1 12V13C1 14.1046 1.89543 15 3 15H13C14.1046 15 15 14.1046 15 13V12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    `,
    category: ICON_CATEGORY.UTILITY
  },
  empty: {
    svg: `<path d="M2 5V4a2 2 0 012-2h1M14 5V4a2 2 0 00-2-2h-1M5 14H4a2 2 0 01-2-2v-1M11 14h1a2 2 0 002-2v-1"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  error: {
    svg: `<path d="M6 6l4 4M10 6l-4 4"/>
    <path d="M11 1H5L1 5v6l4 4h6l4-4V5l-4-4z"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  'eye-closed': {
    svg: `<path d="M15 6s-3.134 4-7 4-7-4-7-4"/>
    <path d="M3.5 8.5L1 11M12.5 8.5L15 11M8 10v3"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  'eye-open': {
    svg: `<path d="M15 8s-3.134-4-7-4-7 4-7 4"/>
    <path d="M8 11a2 2 0 100-4 2 2 0 000 4z"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  ghost: {
    svg: `<path d="M15 8v7l-3.5-3L8 15l-3.5-3L1 15V8a7 7 0 0 1 14 0Z"/>
    <path d="M10 7h.007M6 7h.007"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  graph: {
    svg: `<path d="M15 15H4a2 2 0 01-2-2V3"/>
    <path d="M2 11l5-5 3 3 4-4"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  'info-bubble': {
    svg: `<circle cx="8" cy="8" r="7"/>
    <path d="M8 8v3"/>
    <path d="M8 5h.007"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  lock: {
    svg: `<path d="M12.6667 7.33334H3.33333C2.59695 7.33334 2 7.9303 2 8.66668V13.3333C2 14.0697 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0697 14 13.3333V8.66668C14 7.9303 13.403 7.33334 12.6667 7.33334Z" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.66667 7.33334V4.66668C4.66667 3.78262 5.01786 2.93478 5.64298 2.30965C6.2681 1.68453 7.11595 1.33334 8 1.33334C8.88406 1.33334 9.73191 1.68453 10.357 2.30965C10.9821 2.93478 11.3333 3.78262 11.3333 4.66668V7.33334" stroke-linecap="round" stroke-linejoin="round"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  'magnifying-glass': {
    svg: `<path d="M7.5 12a5.5 5.5 0 100-11 5.5 5.5 0 000 11zM11.5 10.5L15 14"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  menu: {
    svg: `<path d="M2 3h12M2 8h12M2 13h12"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  minus: {
    svg: `<path d="M2 8h12"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  pause: {
    svg: `<path d="M6.66667 2.66666H4V13.3333H6.66667V2.66666Z" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 2.66666H9.33333V13.3333H12V2.66666Z" stroke-linecap="round" stroke-linejoin="round"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  play: {
    svg: `<path d="M14 8L4 2v12l10-6z"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  plus: {
    svg: `<path d="M8 14V2M2 8h12H2z"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  spinner: {
    svg: `<path d="M15 8a7 7 0 11-7-7"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  star: {
    svg: `<path d="M7.99999 1.33334L10.06 5.50668L14.6667 6.18001L11.3333 9.42668L12.12 14.0133L7.99999 11.8467L3.87999 14.0133L4.66666 9.42668L1.33333 6.18001L5.93999 5.50668L7.99999 1.33334Z" stroke-linecap="round" stroke-linejoin="round"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  table: {
    svg: `<path d="M1 6h14M8 6v8"/>
    <path d="M1 4a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2H3a2 2 0 01-2-2V4z"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  tick: {
    svg: `<path d="M15 2L6 14l-4-4"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  user: {
    svg: `<path d="M2.708 14A7.97 7.97 0 018 12a7.97 7.97 0 015.291 2"/>
    <path d="M4,5a4,4 0 1,0 8,0a4,4 0 1,0 -8,0"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  warning: {
    svg: `<path d="M8 6v2"/>
    <path d="M5.7 2.7c.877-1.84 3.722-1.84 4.6 0l4.1 8.1c.834 1.748-.34 3.6-2.098 3.6h-8.6c-1.759 0-2.936-1.851-2.102-3.6l4.1-8.1Z" clip-rule="evenodd"/>
    <path d="M8 11h.007"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  archive: {
    svg: `<path d="M14 5.333V14H2V5.333M15.333 2H.667v3.333h14.666V2ZM6.667 8h2.666"/>`,
    category: ICON_CATEGORY.UTILITY
  },
  // Social icons
  'logo-instagram': {
    svg: `<g fill-rule="nonzero"><path d="M20 3.609c5.339 0 5.97.02 8.08.116 1.949.09 3.007.415 3.712.689.868.32 1.654.831 2.299 1.495a6.195 6.195 0 011.495 2.3c.274.704.6 1.763.689 3.712.096 2.108.116 2.74.116 8.08 0 5.338-.02 5.97-.116 8.079-.09 1.949-.415 3.008-.689 3.712a6.621 6.621 0 01-3.794 3.795c-.705.273-1.763.6-3.713.688-2.108.096-2.74.117-8.079.117-5.34 0-5.971-.02-8.08-.117-1.949-.089-3.007-.415-3.712-.688A6.195 6.195 0 015.91 34.09a6.195 6.195 0 01-1.495-2.299c-.274-.704-.6-1.763-.689-3.712C3.63 25.97 3.61 25.339 3.61 20c0-5.338.02-5.97.116-8.08.09-1.948.415-3.007.689-3.712A6.195 6.195 0 015.909 5.91a6.195 6.195 0 012.3-1.495c.704-.274 1.762-.6 3.712-.689 2.108-.096 2.74-.116 8.08-.116H20zm0-3.603c-5.43 0-6.111.023-8.243.12-2.128.098-3.582.436-4.853.93a9.8 9.8 0 00-3.542 2.306 9.8 9.8 0 00-2.306 3.541C.562 8.175.224 9.628.127 11.757.029 13.889.007 14.57.007 20s.022 6.111.12 8.243c.097 2.129.435 3.582.93 4.854a9.8 9.8 0 002.305 3.54 9.8 9.8 0 003.542 2.307c1.272.494 2.725.832 4.853.93 2.133.097 2.813.12 8.243.12s6.111-.023 8.244-.12c2.128-.098 3.581-.436 4.853-.93a10.224 10.224 0 005.847-5.847c.495-1.272.833-2.726.93-4.854.097-2.132.12-2.813.12-8.243s-.023-6.111-.12-8.243c-.097-2.129-.435-3.582-.93-4.854a9.8 9.8 0 00-2.306-3.54 9.8 9.8 0 00-3.541-2.307C31.825.562 30.372.224 28.243.127 26.111.029 25.43.007 20 .007h0z"></path><path d="M20 9.733C14.33 9.733 9.733 14.33 9.733 20c0 5.67 4.597 10.267 10.267 10.267 5.67 0 10.267-4.597 10.267-10.267 0-5.67-4.597-10.267-10.267-10.267zm0 16.932a6.665 6.665 0 110-13.33 6.665 6.665 0 010 13.33z"></path><circle cx="30.673" cy="9.327" r="2.399"></circle></g>`,
    viewBox: '0 0 40 40',
    category: ICON_CATEGORY.SOCIAL
  },
  'logo-facebook': {
    svg: `<path d="M16.375 6.63c-2.843 0-3.393 1.4-3.393 3.456v4.53h6.78l-.883 7.098h-5.897V40h-7.07V21.714H0v-7.098h5.912V9.382C5.912 3.308 9.491 0 14.716 0c2.506 0 4.657.192 5.284.278v6.35l-3.625.002z" fill-rule="evenodd"></path>`,
    viewBox: '0 0 20 40',
    category: ICON_CATEGORY.SOCIAL
  },
  'logo-linkedin': {
    svg: `<g fill-rule="evenodd"><path d="M.8 40.001h8.312V13.285H.8zM4.959 9.63a4.814 4.814 0 110-9.629 4.817 4.817 0 014.814 4.812A4.818 4.818 0 014.959 9.63M40.208 40h-8.296V27.008c0-3.098-.06-7.084-4.314-7.084-4.324 0-4.984 3.374-4.984 6.86V40h-8.292V13.284h7.96v3.65h.114c1.106-2.102 3.818-4.316 7.858-4.316 8.402 0 9.954 5.53 9.954 12.728V40z"></path></g>`,
    viewBox: '0 0 41 40',
    category: ICON_CATEGORY.SOCIAL
  },
  'logo-twitter': {
    svg: `<path d="M15.724 40c18.869 0 29.188-15.388 29.188-28.732 0-.436-.01-.872-.028-1.306A20.669 20.669 0 0050 4.734a20.653 20.653 0 01-5.89 1.59c2.117-1.25 3.742-3.228 4.51-5.586a20.757 20.757 0 01-6.513 2.452A10.324 10.324 0 0034.617 0C28.953 0 24.36 4.522 24.36 10.096c0 .792.09 1.564.266 2.302C16.1 11.976 8.54 7.958 3.48 1.848a9.944 9.944 0 00-1.39 5.076c0 3.504 1.811 6.596 4.566 8.404a10.3 10.3 0 01-4.647-1.262c-.002.042-.002.084-.002.13 0 4.89 3.538 8.972 8.231 9.898-.863.23-1.77.356-2.706.356a10.53 10.53 0 01-1.926-.182c1.306 4.012 5.091 6.932 9.582 7.012a20.795 20.795 0 01-12.742 4.324c-.827 0-1.643-.048-2.446-.142a29.364 29.364 0 0015.724 4.536" fill-rule="evenodd"></path>`,
    viewBox: '0 0 50 40',
    category: ICON_CATEGORY.SOCIAL
  },
  'logo-youtube': {
    svg: `<path d="M8.339 15V5L17 10 8.34 15zM23.144 3.909c-.433-1.543-1.672-2.743-3.24-3.075a37.895 37.895 0 00-15.807 0C2.527 1.165 1.29 2.365.856 3.908c-1.141 4.061-1.141 8.123 0 12.184.434 1.543 1.672 2.744 3.24 3.075a37.895 37.895 0 0015.807 0c1.57-.331 2.808-1.532 3.241-3.075 1.141-4.061 1.141-8.123 0-12.184h0z" fill-rule="evenodd"></path>`,
    viewBox: '0 0 24 20',
    category: ICON_CATEGORY.SOCIAL
  }
};
